import React from 'react';

import "./Default.css"


const Default = () => {
    return (
        <div className="container">
            <div className="background-logo"></div>
            <div className="default-div">
                <p className="default-content">Please select a section from the sidebar</p>
            </div>
        </div>
    );
};

export default Default;